import { render, staticRenderFns } from "./HistoryBill.vue?vue&type=template&id=05488de7&scoped=true&"
import script from "./HistoryBill.vue?vue&type=script&lang=js&"
export * from "./HistoryBill.vue?vue&type=script&lang=js&"
import style0 from "./HistoryBill.vue?vue&type=style&index=0&id=05488de7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05488de7",
  null
  
)

export default component.exports